module.exports = __webpack_public_path__ + "static/media/gocardless.d0884dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gocardless.jpg
// module id = 582
// module chunks = 0